module.exports = __webpack_public_path__ + "brandon_med_it-webfont.8598d3f62d3eaf332190.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_med_it-webfont.woff2
// module id = 946
// module chunks = 7